import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import * as basicLightbox from 'basiclightbox';
import 'basiclightbox/src/styles/main.scss';
import Event from '../utils/Event';
import { MD } from '../global_vars';
import { animateText } from '../utils/miscellanea';
import GFade from '../components/gfade/GFade';
import { clearAllBodyScrollLocks, disableBodyScroll } from 'body-scroll-lock';

interface VMService {
  lbInstance: basicLightbox.BasicLightBox | null;
}

@Component({
  components: {
    GFade
  }
})
class VMService extends Vue {
  openDesc(key: string) {

    this.lbInstance = basicLightbox.create(
      document.querySelector(`#service1-desc${key}`)!.innerHTML,
      {
        className: 'lb-th1',
        onShow: (_) => {
          disableBodyScroll(document.querySelector('.lb')!!);
          return true;
        },
        onClose: (_) => {
          clearAllBodyScrollLocks();
          return true;
        }
      }
    );

    this.lbInstance.show();
  }

  mounted(): void {
    Event.listen('close-service-desc', () => {
      this.lbInstance?.close();
    });

    if (MD.mobile()) return;
    animateText(<HTMLElement>this.$refs.title).then();
  }

  created(): void {
    this.lbInstance = null;
  }
}

export default VMService;